import React, { useContext } from 'react'
import { Link } from 'pcln-design-system'
import { ContentfulRichText } from '@pcln/contentful-components'
import { MerchModule } from '@pcln/marketing'
import analytics from '@/shared-utils/analytics'
import BootstrapDataContext from '@/context/BootstrapDataContext'
import { CustomMerchModule } from '@/types'
import useGoogleAnalyticsTracking from './useGoogleAnalyticsTracking'
import LayoutComponentWrapper from '../LayoutComponentWrapper'

function MerchModuleWrapper({ content }: { content: CustomMerchModule }) {
  const { isMobile } = useContext(BootstrapDataContext)
  const {
    columnDisplayOptions,
    overline,
    heading,
    mediaDisplay,
    mediaPosition,
    mediaDisplayRatio,
    backgroundColor,
    textAlign,
    media,
    primaryCallToAction,
    paragraph,
    backgroundDisplay,
    hideMediaOnMobile,
    analyticsTracking,
    ...props
  } = content
  useGoogleAnalyticsTracking(analyticsTracking)
  const moduleButtons = primaryCallToAction && (
    <Link
      key={primaryCallToAction.ariaLabel}
      variation="fill"
      href={primaryCallToAction.url}
      target={primaryCallToAction.openInNewTab ? '_blank' : undefined}
      rel={primaryCallToAction.openInNewTab ? 'noopener' : undefined}
      aria-label={primaryCallToAction.ariaLabel}
      onClick={() => {
        if (primaryCallToAction.analyticsTracking?.action) {
          analytics.fireEvent({
            action: primaryCallToAction.analyticsTracking.action,
            category: primaryCallToAction.analyticsTracking.category,
            label: primaryCallToAction.analyticsTracking.label
          })
        }
      }}
    >
      {primaryCallToAction.label}
    </Link>
  )

  const isBoxCheck = backgroundDisplay === 'box'
  const imageDisplayMobile = hideMediaOnMobile === false
  return (
    <LayoutComponentWrapper>
      <MerchModule
        isBox={isBoxCheck}
        columnVariation={['100', null, columnDisplayOptions]}
        tagline={overline}
        headline={heading}
        mediaDisplay={mediaDisplay}
        mediaPosition={mediaPosition}
        imageAspectRatio={mediaDisplayRatio}
        imageDisplayMobile={imageDisplayMobile}
        backgroundColor={backgroundColor}
        isMobile={isMobile}
        {...props}
        textAlign={textAlign}
        minImageHeight="400px"
        imageUrl={media?.file.url ? `${media.file.url}?fm=webp` : undefined}
        imageAlt={media?.description}
        callToAction={primaryCallToAction}
        headingTextStyle="heading1"
        taglineTextStyle="overline"
        bodyLineHeight="25px"
        headingMB="0px"
        body={
          <ContentfulRichText
            color="text.dark"
            textStyle="article"
            fontSize={3}
            body={paragraph as any}
          />
        }
        actions={moduleButtons}
      />
    </LayoutComponentWrapper>
  )
}

export default MerchModuleWrapper
